import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type GroundingCommandBarSlots = {
  root: NonNullable<Slot<'div'>>;
};

/**
 * GroundingCommandBar Props
 */
export type GroundingCommandBarProps = ComponentProps<GroundingCommandBarSlots> & {};

/**
 * State used in rendering GroundingCommandBar
 */
export type GroundingCommandBarState = ComponentState<GroundingCommandBarSlots>;
// TODO: Remove semicolon from previous line, uncomment next line, and provide union of props to pick from GroundingCommandBarProps.
// & Required<Pick<GroundingCommandBarProps, 'propName'>>
